import React from 'react';
import Tab, { TabGroup } from '@amzn/meridian/tab';

interface tabGroupWrapperProps {
  currentTab: string;
  setCurrentTab: (newTab: string) => void;
}

const TabGroupWrapper = ({ currentTab, setCurrentTab }: tabGroupWrapperProps) => {
  return (
    <TabGroup value={currentTab} onChange={setCurrentTab}>
      <Tab value="job-config">Job Configuration</Tab>
      <Tab value="precision-upload">Precision Upload</Tab>
    </TabGroup>
  );
};

export default TabGroupWrapper;
